import React from 'react';
import CustomIntlProvider from 'components/CustomIntlProvider';
import { Page } from 'components/shared/Page/Page';
import Router from '@alltrails/shared/components/ReactRouter';
import usePathname from 'hooks/usePathname';
import { Context } from 'types/Context';
import * as styles from './styles/styles.module.scss';
import AboutContent from './AboutContent';

type AboutProps = {
  context: Context;
};

const About = ({ context }: AboutProps): JSX.Element => {
  const fullpath = usePathname();
  return (
    <div className={styles.pageContainer}>
      <Page context={context}>
        <Router fullpath={fullpath}>
          <CustomIntlProvider>
            <AboutContent context={context} />
          </CustomIntlProvider>
        </Router>
      </Page>
    </div>
  );
};

export { About as default, AboutProps };
